const USE_AUTHENTICATOR_ERROR = '`useAuthenticator` must be used inside an `Authenticator.Provider`.';

export { USE_AUTHENTICATOR_ERROR };
